// @spec GHG-STR-102
'use client';

import { createFileRoute } from '@tanstack/react-router';

import { GhgActivityGroupsPage } from '@/features/ghg/pages/GhgActivityGroupsPage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/ghg/activity-groups')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.facilitiesAndActivityGroups'),
  }),
  component: ActivityGroupsPage,
});

function ActivityGroupsPage() {
  return <GhgActivityGroupsPage />;
}
